import { render } from "./OfficialCommunicationPopup.vue?vue&type=template&id=e3cb92d2&scoped=true&ts=true"
import script from "./OfficialCommunicationPopup.vue?vue&type=script&lang=ts"
export * from "./OfficialCommunicationPopup.vue?vue&type=script&lang=ts"

import "./OfficialCommunicationPopup.vue?vue&type=style&index=0&id=e3cb92d2&lang=css&scoped=true"

import exportComponent from "/codebuild/output/src1651641719/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e3cb92d2"]])

export default __exports__